<template>
  <div class="wd-flex wd-justify-end wd-items-start">
    <v-btn class="wd-mx-0" width="20" height="20" color="orange50" :disabled="number <= minNum" icon variant="text" @click="subtractNum">
      <v-icon size="20"> mdi-minus-circle-outline </v-icon>
    </v-btn>

    <p class="wd-mx-6 wd-mb-0">{{ number }}</p>

    <v-btn class="wd-mx-0" width="20" height="20" color="orange50" :disabled="number >= maxNum" icon variant="text" @click="addNum">
      <v-icon size="20"> mdi-plus-circle-outline </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { syncRefs } from '@vueuse/core'

export default defineComponent({
  name: 'AddSubNumberPicker',
  props: {
    value: { type: Number, default: 0 },
    minNum: { type: Number, default: 0 },
    maxNum: { type: Number, default: 99 },
  },
  emits: ['input'],
  setup(props) {
    const number = ref(0)
    syncRefs(() => props.value, number)

    return {
      number,
    }
  },
  mounted() {
    this.$emit('input', this.number)
  },
  methods: {
    subtractNum() {
      this.number -= 1
      this.$emit('input', this.number)
    },
    addNum() {
      this.number += 1
      this.$emit('input', this.number)
    },
  },
})
</script>
